module.exports = __webpack_public_path__ + "static/media/renovacao_icon.b4b16767.svg";